module.exports = __webpack_public_path__ + "img/cover-3.67dc9bfd.jpg";